export const commentsTypes = [
  { label: 'Все', code: 'COMMENTS' },
  { label: 'Результаты задач', code: '@result' },
  { label: 'Причина упущенных', code: 'MISSING' },
  { label: 'Фин сервис', code: 'FINSERVICE' }
]
